import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { RiArrowGoBackFill } from 'react-icons/ri';
import TimelineTable from '../../components/TimelineTable/TimelineTable';
import ToastManager from '../../components/Toast/ToastManager';
import api from '../../services/api';
import { useToast } from '../../hooks/useToast';
import { useGestanteFormConfig } from '../../hooks/useGestanteFormConfig';
import { orientacaoSexualLabel } from '../../enums/OrientacaoSexual';
import { identidadeGeneroLabel } from '../../enums/IdentidadeGenero';
import { podeApresentarIdentidade } from '../../components/Forms/IdentidadeGeneroSection';
import { ViewContainer, GestanteInfo, InfoGrid, InfoField, InfoLabel, InfoValue, Title, BackButton } from './ViewPage.styles';

const GestanteViewPage = () => {
  const { cpf } = useParams();
  const navigate = useNavigate();
  const { toasts, removeToast, showSuccess, showError } = useToast();
  const { gender_orientation_ui_enabled: identidadeFlag } = useGestanteFormConfig();

  const [gestanteData, setGestanteData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Buscar dados da gestante
  const fetchGestanteData = async () => {
    try {
      const response = await api.get(`/gestante/${cpf}/list`);
      if (!response.status === 200) throw new Error('Erro ao buscar dados');
      setGestanteData(response.data);
    } catch (err) {
      console.error("Erro ao buscar dados da gestante:", err);
      setError(err.message);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchGestanteData();
      setLoading(false);
    };

    if (cpf) {
      fetchData();
    }
  }, [cpf]);

  if (loading) return <p>Carregando...</p>;
  if (error) return <p>Erro: {error}</p>;
  if (!gestanteData) return <p>Gestante não encontrada</p>;

  return (
    <ViewContainer>
      <BackButton onClick={() => navigate('/gestante')}>
        <RiArrowGoBackFill size={20} color='#444' />
       Voltar para a lista
      </BackButton>

      <Title>Detalhes da Gestante</Title>

      <GestanteInfo>
        <InfoGrid>
          <InfoField>
            <InfoLabel>CPF da Gestante:</InfoLabel>
            <InfoValue>{gestanteData.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')}</InfoValue>
          </InfoField>

          <InfoField>
            <InfoLabel>Nome da Gestante:</InfoLabel>
            <InfoValue>{gestanteData.nome}</InfoValue>
          </InfoField>

          <InfoField>
            <InfoLabel>CNS da Gestante:</InfoLabel>
            <InfoValue>{gestanteData.cns}</InfoValue>
          </InfoField>

          <InfoField>
            <InfoLabel>Município da Gestante:</InfoLabel>
            <InfoValue>{gestanteData.municipio.nome}</InfoValue>
          </InfoField>

          <InfoField>
            <InfoLabel>Município (IBGE):</InfoLabel>
            <InfoValue>{gestanteData.municipio_cod_ibge}</InfoValue>
          </InfoField>

          <InfoField>
            <InfoLabel>Status da Gestante:</InfoLabel>
            <InfoValue>{gestanteData.habilitado ? 'Ativa' : 'Inativa'}</InfoValue>
          </InfoField>

          {identidadeFlag && podeApresentarIdentidade(gestanteData.data_nascimento) && (
            <>
              <InfoField>
                <InfoLabel>Orientação Sexual:</InfoLabel>
                <InfoValue>
                  {orientacaoSexualLabel(
                    gestanteData.orientacao_sexual,
                    gestanteData.orientacao_sexual_other
                  )}
                </InfoValue>
              </InfoField>

              <InfoField>
                <InfoLabel>Identidade de Gênero:</InfoLabel>
                <InfoValue>
                  {identidadeGeneroLabel(
                    gestanteData.identidade_genero,
                    gestanteData.identidade_genero_other
                  )}
                </InfoValue>
              </InfoField>
            </>
          )}
        </InfoGrid>
      </GestanteInfo>

      <TimelineTable
        gestante={gestanteData}
        showSuccess={showSuccess}
        showError={showError}
      />

      {/* Toast Manager para notificações */}
      <ToastManager toasts={toasts} removeToast={removeToast} />
    </ViewContainer>
  );
};

export default GestanteViewPage;
